import { injectable } from 'inversify';
import type { ISceneItemDetailsFactory } from './interfaces';
import { SceneItemKind } from './interfaces';
import { SplineDetails } from './models/SplineDetails';

@injectable()
export class SceneItemDetailsFactory implements ISceneItemDetailsFactory {
  public createDetails(kind: SceneItemKind): unknown {
    if (kind === SceneItemKind.SplineAreaMeasurement || kind === SceneItemKind.UnrestrictedSplineAreaMeasurement) {
      return new SplineDetails();
    } else if (kind === SceneItemKind.ValueMeasurement) {
      return new SplineDetails();
    } else return undefined;
  }
}
